import React from 'react';
import PropTypes from 'prop-types';
const moment = require('moment');

const DateDivider = ({ ...props }) => {
  DateDivider.propTypes = {
    date: PropTypes.string
  };

  const todayDate = moment().format('dddd - MMMM D, YYYY');

  function isToday (date) {
    const givenDate = date && moment(date).format('dddd - MMMM D, YYYY');
    return givenDate === todayDate;
  }

  const containerClass = 'date-container' + (isToday(props.date) ? ' today' : '');
  return (
    <React.Fragment>
      <div className={containerClass}>
        {
          isToday(props.date) && <span>Today</span>
        }
        <span>{moment(props.date).format('dddd - MMMM D, YYYY')}</span>
      </div>
    </React.Fragment>
  );
};

export default DateDivider;
